// noinspection ES6CheckImport,DuplicatedCode

import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import { formatDate, humanizeConversion } from '~/common';
import TableHead from './TableHead/TableHead';

function getConversion(key, day, report) {
    const value = report[key][formatDate(day, 'yyyy-MM-dd')];
    // noinspection JSUnresolvedVariable
    if (value && value.accepted) {
        // noinspection JSUnresolvedVariable
        return value.conversion;
    }
    return 0;
}

const Component = (props) => {
    // noinspection JSUnresolvedVariable
    return (
        <TableContainer className="table-container-right" responsive={true}>
            <Table>
                <TableHead {...props}/>
                <TableBody>
                    {Object.keys(props.report).map((key, id) => (
                        <TableRow key={id}>
                            {props.days.map((day, id) => {
                                let conversion = getConversion(key, day, props.report);
                                return (conversion !== 0)
                                    ? <TableCell key={id} className="conversion">
                                        <Typography align="right">{humanizeConversion(conversion)}</Typography>
                                    </TableCell>
                                    : <TableCell key={id} className="conversion">
                                        <Typography align="center">-</Typography>
                                    </TableCell>;
                            })}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    days: PropTypes.array.isRequired,
    report: PropTypes.object.isRequired,
};

let MemoizedComponent = React.memo(Component, (prevProps, nextProps) => {
    // noinspection JSUnresolvedVariable
    let prevReport = Object.keys(prevProps.report);
    // noinspection JSUnresolvedVariable
    let nextReport = Object.keys(nextProps.report);

    if (prevReport.length) {
        let equal = prevReport.every((key, index) => nextReport[index] === key);
        if (!equal) {
            return false;
        }
    }
    return true;
});

export default MemoizedComponent;
